import axios from 'axios';
import firebase from 'firebase/app';
import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "value-prop",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Value Propostion Added", intent: Intent.PRIMARY, timeout: 1000});
}

export const FormatVP = (compName, value, pain, auth, setShowVpropOB, fbProfile, setShowSpinner) =>{
    //set generating value prop here
    setShowSpinner(true)
    var company = compName
    var valueProp = value
    // var pain = pain

    var format = `${company}\nValue Prop: ${valueProp}\nPain: ${pain}`

    const message= { Input: format }
        //first classify interest
        axios
        .post('https://boundapiv2.herokuapp.com/formattedVP', message)
        .then((response) => {
            // console.log(response)
            var str = response.data
            var res = str.split("Pain Formatted:")
            // console.log(res)
            var vProp = res?.[0]?.replace("Value Prop Formatted:", "")
            var vpTrim = vProp.trim()
            var Pain = res?.[1].trim()
            
            // console.log(vpTrim)
            // console.log(Pain)

            firebase
            .firestore()
            .collection('organizations')
            .doc(fbProfile.company)
            .collection('valueProps')
            .doc()
            .set({
                Pain: Pain,
                ValueProp: vpTrim,
                Title: `${compName} - General`
            }).then(() =>{
                firebase
                .firestore()
                .collection('onboards')
                .doc(auth.uid)
                .update({
                    onboarded: 'yes'
                }) 
            }).then(
                setShowSpinner(false),
                setShowVpropOB(false),
            )
            //set value prop generated here and that we done

            //then set all the other stuff here that can be finished
        })
}

export const AutoGenVP = (compName, value, pain, auth, setOpenModal, fbProfile, setShowSpinner, FBvalueProp, setError) =>{
    //set generating value prop here
    // setError("")
    setShowSpinner(true) 
    var company = compName
    var valueProp = value
    // var pain = pain

    var format = `${company}\nValue Prop: ${valueProp}\nPain: ${pain}`

    // console.log("in here")

    const message= { Input: format }
        //first classify interest
        axios
        .post('https://boundapiv2.herokuapp.com/formattedVP', message)
        .then((response) => {
            // console.log(response)
            var str = response.data
            // console.log(str)

            if (str === "Oops, the content generated was a bit sensitive. Click regenerate for new content :)"){
                setError(
                    "Oops, the output we created was a bit sensitive. Try updating some sensitive or vulgar words in your about product and pain sections, and try again."
                    )
            }
            else if(response.data.length > 80){
                var res = str.split("Pain Formatted:")
                // console.log(res)
                var vProp = res?.[0]?.replace("Value Prop Formatted:", "")
                var vpTrim = vProp.trim()
                var Pain = res?.[1].trim()
    
                
                
                // console.log(vpTrim)
                // console.log(Pain)
    
                firebase
                .firestore()
                .collection('organizations')
                .doc(fbProfile.company)
                .collection('valueProps')
                .doc()
                .set({
                    Pain: Pain,
                    ValueProp: vpTrim,
                    Title: `${compName} - General ${FBvalueProp?.length}`
                }).then(
                    setShowSpinner(false),
                    setOpenModal(false),
                    // console.log("posted"),
                    // setShowOBdone(true),
                    showToast()
                )   
            } else{
                setShowSpinner(false)
                setError(
                    "Oops, we couldn't generate a value proposition for you. Try adding a bit more about your company in the pain and what you do section and try again. Check out the examples if you're having trouble."
                    )
            }

        })
}

export const AutoGenVPOnboard = (compName, value, pain, auth, setOpenModal, fbProfile, setShowSpinner, FBvalueProp, setShowOBdone, setError) =>{
    //set generating value prop here
    setShowSpinner(true) 
    var company = compName
    var valueProp = value
    // var pain = pain

    var format = `${company}\nValue Prop: ${valueProp}\nPain: ${pain}`

    // console.log("in here")

    const message= { Input: format }
        //first classify interest
        axios
        .post('https://boundapiv2.herokuapp.com/formattedVP', message)
        .then((response) => {
            // console.log(response)
            var str = response.data

            if (str === "Oops, the content generated was a bit sensitive. Click regenerate for new content :)"){
                setError(
                    "Oops, the output we created was a bit sensitive. Try updating some sensitive or vulgar words in your about product and pain sections, and try again."
                    )
            }
            else if(response.data.length > 80){
                var res = str.split("Pain Formatted:")
                // console.log(res)
                var vProp = res?.[0]?.replace("Value Prop Formatted:", "")
                var vpTrim = vProp.trim()
                var Pain = res?.[1].trim()
    
                firebase
                .firestore()
                .collection('organizations')
                .doc(fbProfile.company)
                .collection('valueProps')
                .doc()
                .set({
                    Pain: Pain,
                    ValueProp: vpTrim,
                    Title: `${compName} - General ${FBvalueProp?.length}`
                }).then(
                    setShowSpinner(false),
                    setOpenModal(false),
                    // console.log("posted"),
                    setShowOBdone(true),
                    showToast()
                )   
            } else{
                setShowSpinner(false)
                setError(
                    "Oops, we couldn't generate a value proposition for you. Try adding a bit more about your company in the pain and what you do section and try again. Check out the examples if you're having trouble."
                    )
            }
        })
}